import { api } from "@/lib/api";

// Facebook-style call-to-action buttons (FR labels).
export const CTA_LABELS = {
  learn_more: "En savoir plus",
  get_quote: "Obtenir un devis",
  shop_now: "Acheter",
  sign_up: "S'inscrire",
  contact_us: "Nous contacter",
  call_now: "Appeler",
  whatsapp: "Message WhatsApp",
  send_message: "Envoyer un message",
  book_now: "Réserver",
  donate_now: "Faire un don",
  download: "Télécharger",
  subscribe: "S'abonner",
  see_menu: "Voir le menu",
  get_offer: "Obtenir l'offre",
  apply_now: "Postuler",
  order_now: "Commander",
  see_details: "Voir les détails",
  install_now: "Installer",
};

export const CTA_OPTIONS = Object.entries(CTA_LABELS).map(([value, label]) => ({ value, label }));

// Destination types the advertiser can pick.
export const CTA_TYPES = [
  { value: "none", label: "Aucun bouton" },
  { value: "lead_form", label: "Formulaire de prospects (natif)" },
  { value: "url", label: "Lien externe (site web)" },
  { value: "chat", label: "Discussion Yalola" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "phone", label: "Appel téléphonique" },
];

export const ctaLabel = (ad) => CTA_LABELS[ad?.label] || CTA_LABELS.learn_more;

// A small helper so the CTA "chip" above the button reads like Facebook.
export const ctaDomain = (ad) => {
  if (ad?.form_label) return ad.form_label;
  if (ad?.type === "lead_form") return "Formulaire";
  if (ad?.type === "url" && ad.value) {
    try { return new URL(ad.value.startsWith("http") ? ad.value : `https://${ad.value}`).hostname.replace(/^www\./, ""); }
    catch { return "Site web"; }
  }
  if (ad?.type === "whatsapp") return "WhatsApp";
  if (ad?.type === "phone") return "Téléphone";
  if (ad?.type === "chat") return "Discussion";
  return "Sponsorisé";
};

// Run the CTA: tracks the click then routes to the right destination.
export const performAdCta = (ad, { nav, openChat, openLead, author } = {}) => {
  if (!ad?.id) return;
  api.post(`/ads/${ad.id}/click`).catch(() => {});
  const type = ad.type || (ad.value ? "url" : "none");
  if (type === "lead_form") { openLead?.(); return; }
  if (type === "chat") {
    // Carte de contexte façon Messenger (« Publicité : <titre> ») : aperçu immédiat côté client, snapshot re-résolu par le serveur à l'envoi.
    const ref = { type: "ad", id: ad.id, title: ad.title || ad.headline || "", text: ad.headline || ad.description || "", image_url: ad.image_url || null };
    openChat?.(author || { id: ad.advertiser_id }, { draft: ad.headline || ad.description || "", ref });
    return;
  }
  if (type === "whatsapp" && ad.value) {
    let num = ad.value.replace(/\D/g, "");   // digits only
    if (num.startsWith("00")) num = num.slice(2); // strip international 00 prefix
    const msg = encodeURIComponent("Bonjour 👋 je vous contacte via Yalola.");
    // api.whatsapp.com keeps 4-byte emoji intact — the wa.me redirect re-decodes them into « � ».
    window.open(`https://api.whatsapp.com/send?phone=${num}&text=${msg}`, "_blank", "noopener");
    return;
  }
  if (type === "phone" && ad.value) { window.location.href = `tel:${ad.value}`; return; }
  const url = ad.value || "";
  if (!url) return;
  if (url.startsWith("/")) nav?.(url);
  else window.open(url.startsWith("http") ? url : `https://${url}`, "_blank", "noopener");
};
